var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 248,
    height: 181,
    viewBox: "0 0 248 181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2457",
    "data-name": "Grupo 2457",
    transform: "translate(-25.673 -263.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2460",
    "data-name": "Grupo 2460",
    transform: "translate(25.673 261.796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_1323",
    "data-name": "Ret\\xE2ngulo 1323",
    transform: "translate(7 1.299)",
    fill: "#121212",
    stroke: "#d3ff9a",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0H229a5,5,0,0,1,5,5V151a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V6A6,6,0,0,1,6,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,1H229a4,4,0,0,1,4,4V149a1,1,0,0,1-1,1H2a1,1,0,0,1-1-1V6A5,5,0,0,1,6,1Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_1324",
    "data-name": "Ret\\xE2ngulo 1324",
    transform: "translate(0 150.299)",
    fill: "#121212",
    stroke: "#d3ff9a",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 7,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 246,
    height: 5,
    rx: 1,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2458",
    "data-name": "Grupo 2458",
    transform: "translate(102.409 324.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1743",
    "data-name": "Grupo 1743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_422",
    "data-name": "Caminho 422",
    d: "M25.507,11.083a.171.171,0,0,0,.171-.171v-1.2a.171.171,0,0,0-.171-.171H22.36a.77.77,0,0,0-.544.226L19.686,11.9H15.111l5.52-5.52a.171.171,0,0,0,0-.242L19.542,5.048a.171.171,0,0,0-.242,0l-5.52,5.52V5.992l2.129-2.129a.77.77,0,0,0,.226-.544V.171A.171.171,0,0,0,15.964,0h-1.2A.171.171,0,0,0,14.6.171V3L12.839,4.756,11.083,3V.171A.171.171,0,0,0,10.912,0h-1.2a.171.171,0,0,0-.171.171V3.318a.77.77,0,0,0,.226.544L11.9,5.992v4.576l-5.52-5.52a.171.171,0,0,0-.242,0L5.048,6.137a.171.171,0,0,0,0,.242l5.52,5.52H5.992L3.863,9.769a.77.77,0,0,0-.544-.226H.171A.171.171,0,0,0,0,9.715v1.2a.171.171,0,0,0,.171.171H3l1.756,1.756L3,14.6H.171A.171.171,0,0,0,0,14.766v1.2a.171.171,0,0,0,.171.171H3.318a.77.77,0,0,0,.544-.226L5.992,13.78h4.576L5.048,19.3a.171.171,0,0,0,0,.242L6.137,20.63a.171.171,0,0,0,.242,0l5.52-5.52v4.576L9.769,21.816a.77.77,0,0,0-.226.544v3.147a.171.171,0,0,0,.171.171h1.2a.171.171,0,0,0,.171-.171V22.679l1.756-1.756L14.6,22.679v2.828a.171.171,0,0,0,.171.171h1.2a.171.171,0,0,0,.171-.171V22.36a.77.77,0,0,0-.226-.544L13.78,19.686V15.11l5.641,5.641,1.331-1.331L15.111,13.78h4.576l2.129,2.129a.77.77,0,0,0,.544.225h3.147a.171.171,0,0,0,.171-.171v-1.2a.171.171,0,0,0-.171-.171H22.679l-1.756-1.756,1.756-1.756ZM12.839,14.131l-1.292-1.292,1.292-1.292,1.292,1.292Z",
    fill: "#a6ff00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1744",
    "data-name": "Grupo 1744",
    transform: "translate(31.283 5.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_423",
    "data-name": "Caminho 423",
    d: "M339.158,61.811c0,2.879-1.919,4.8-5.864,4.8H327v5.331h-2.132V57.013h8.423C337.239,57.013,339.158,58.932,339.158,61.811Zm-2.239,0c0-1.6-1.173-2.772-3.625-2.772H327v5.544h6.29C335.747,64.583,336.919,63.41,336.919,61.811Z",
    transform: "translate(-324.872 -56.587)",
    fill: "#a6ff00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_424",
    "data-name": "Caminho 424",
    d: "M488.98,90.229h2.132v1.877h.107a4.351,4.351,0,0,1,3.518-1.877h1.194v2.026h-1.194c-2.985,0-3.625,1.748-3.625,1.748v7.954H488.98Z",
    transform: "translate(-473.177 -86.604)",
    fill: "#a6ff00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_425",
    "data-name": "Caminho 425",
    d: "M563.781,94.092c0-3.412,2.665-6.077,7.143-6.077s7.143,2.665,7.143,6.077-2.665,6.077-7.143,6.077S563.781,97.5,563.781,94.092Zm12.154,0c0-2.559-1.706-4.265-5.011-4.265s-5.011,1.706-5.011,4.265,1.706,4.265,5.011,4.265S575.935,96.651,575.935,94.092Z",
    transform: "translate(-540.775 -84.603)",
    fill: "#a6ff00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_426",
    "data-name": "Caminho 426",
    d: "M714.713,56.21h2.346a3.36,3.36,0,0,1,3.625-3.625h6.29V54.4H720.9a1.6,1.6,0,0,0-1.706,1.812h7.89V67.938h-2.132V58.022h-5.757v9.915h-2.132V58.022h-2.346Z",
    transform: "translate(-677.173 -52.585)",
    fill: "#a6ff00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_427",
    "data-name": "Caminho 427",
    d: "M857.384,100.144l8.529-7.89v-.107H857.49V90.229h11.3v1.812l-8.529,7.89v.107h8.849v1.919H857.384Z",
    transform: "translate(-806.106 -86.604)",
    fill: "#a6ff00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_1325",
    "data-name": "Ret\\xE2ngulo 1325",
    transform: "translate(56.673 337.095)",
    fill: "#121212",
    stroke: "#d3ff9a",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 107,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 105,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2455",
    "data-name": "Grupo 2455",
    transform: "translate(72.995 378.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_422-2",
    "data-name": "Caminho 422",
    d: "M25.507,11.083a.171.171,0,0,0,.171-.171v-1.2a.171.171,0,0,0-.171-.171H22.36a.77.77,0,0,0-.544.226L19.686,11.9H15.111l5.52-5.52a.171.171,0,0,0,0-.242L19.542,5.048a.171.171,0,0,0-.242,0l-5.52,5.52V5.992l2.129-2.129a.77.77,0,0,0,.226-.544V.171A.171.171,0,0,0,15.964,0h-1.2A.171.171,0,0,0,14.6.171V3L12.839,4.756,11.083,3V.171A.171.171,0,0,0,10.912,0h-1.2a.171.171,0,0,0-.171.171V3.318a.77.77,0,0,0,.226.544L11.9,5.992v4.576l-5.52-5.52a.171.171,0,0,0-.242,0L5.048,6.137a.171.171,0,0,0,0,.242l5.52,5.52H5.992L3.863,9.769a.77.77,0,0,0-.544-.226H.171A.171.171,0,0,0,0,9.715v1.2a.171.171,0,0,0,.171.171H3l1.756,1.756L3,14.6H.171A.171.171,0,0,0,0,14.766v1.2a.171.171,0,0,0,.171.171H3.318a.77.77,0,0,0,.544-.226L5.992,13.78h4.576L5.048,19.3a.171.171,0,0,0,0,.242L6.137,20.63a.171.171,0,0,0,.242,0l5.52-5.52v4.576L9.769,21.816a.77.77,0,0,0-.226.544v3.147a.171.171,0,0,0,.171.171h1.2a.171.171,0,0,0,.171-.171V22.679l1.756-1.756L14.6,22.679v2.828a.171.171,0,0,0,.171.171h1.2a.171.171,0,0,0,.171-.171V22.36a.77.77,0,0,0-.226-.544L13.78,19.686V15.11l5.641,5.641,1.331-1.331L15.111,13.78h4.576l2.129,2.129a.77.77,0,0,0,.544.225h3.147a.171.171,0,0,0,.171-.171v-1.2a.171.171,0,0,0-.171-.171H22.679l-1.756-1.756,1.756-1.756ZM12.839,14.131l-1.292-1.292,1.292-1.292,1.292,1.292Z",
    transform: "translate(0)",
    fill: "#a6ff00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileAppIcon);
export default __webpack_public_path__ + "static/media/mobileAppIcon.d79ea26556bca56c7d8335e81e3408f1.svg";
export { ForwardRef as ReactComponent };